import React, { Component } from 'react';

import {AuthContext} from "../../authContext";
import FormContainer from "../shared/form/FormContainer";
import FormControl from "../shared/form/FormControl";
import TextArea from "../shared/form/TextArea";
import TextInput from "../shared/form/TextInput";
import Button from "../shared/Button";
import PageHeading from '../shared/PageHeading';

import { createProject, editProject } from "../data/dataCIMToolkit";

class AddProject extends Component {
  state = {
    isSaving: false,
    isEditing: false,
    id: null,
    name: "",
    description: "",
    latitude: 51.507397,
    longitude: -0.127668,
    locationMapZoomLevel: 16
  };
  static contextType = AuthContext;
  componentDidMount = async () => {
    if (this.props.projectData) {
      await this.setState({
        id: this.props.projectData.ID,
        name: this.props.projectData.name,
        description: this.props.projectData.description,
        latitude: this.props.projectData.latitude,
        longitude: this.props.projectData.longitude,
        locationMapZoomLevel: this.props.projectData.locationMapZoomLevel
      });
    }
    // console.log("AddProject > componentDidMount > ", this.state);
  };
  handleInput = async (e) => {
    let a = {};
    a[e.currentTarget.name] = e.currentTarget.value;
    await this.setState(a);
  };
  saveProject = async () => {
    await this.setState({isSaving: true});

    if (this.state.id === null) {
      await createProject(this.state, this.context.token);
      //console.log("AddProject > createProjectResponse", createProjectResponse);
      this.props.loadProjects();
    }
    else {
      await editProject(this.state, this.context.token);
      //console.log("AddProject > editProjectResponse", editProjectResponse);
      this.props.loadProjectData();
    }

    await this.setState({isSaving: false});

    this.props.closeForm();
  };
  render() {
    return (
      <FormContainer>

        <PageHeading>
          <div>
            {this.state.id === null ? "Add new project" : "Edit project"}
          </div>
        </PageHeading>

        <FormControl>
          <div style={{margin:"6px 0px 6px 0px"}}>Project name</div>
          <TextInput name="name" value={this.state.name || ""} onChange={this.handleInput} />
        </FormControl>

        <FormControl>
          <div style={{margin:"6px 0px 6px 0px"}}>Description</div>
          <TextArea name="description" rows={10} value={this.state.description || ""} onChange={this.handleInput} />
        </FormControl>

        <div style={{display:"flex", justifyContent:"flex-end", maxWidth: "422px"}}>
          <FormControl horizontal>
            <Button onClick={this.props.closeForm}>Cancel</Button>
            {
              this.state.isSaving === true
              ?
              <Button isSaving={this.state.iSaving}>Saving</Button>
              :
              <Button onClick={this.saveProject}>Save</Button>
            }
          </FormControl>
        </div>

      </FormContainer>
    );
  }
}

export default AddProject;
